import React from "react";
import "./LanguageSwitcher.css";

function LanguageSwitcher({ language = "EN", onChange }) {
  const setActiveLang = (code) => {
    if (typeof onChange === "function") onChange(code);
  };

  return (
    <div className="language-switcher" role="group" aria-label="Language">
      <button
        type="button"
        className={`lang-btn ${language === "EN" ? "active" : ""}`}
        aria-label="Switch to English"
        aria-pressed={language === "EN"}
        onClick={() => setActiveLang("EN")}
      >
        EN
      </button>
      <button
        type="button"
        className={`lang-btn lang-btn-cn ${
          language === "CN" ? "active" : ""
        }`}
        lang="zh-Hans"
        aria-label="切换至简体中文"
        aria-pressed={language === "CN"}
        onClick={() => setActiveLang("CN")}
      >
        中
      </button>
    </div>
  );
}

export default LanguageSwitcher;
